// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"h0-z"};